export default "__VITE_ASSET__CTO6PbD9__"